if (document.querySelector('#MainContent .section---banner:first-child')) {
  document.querySelector('#MainContent .section---banner:first-child').closest('body').classList.add('has--banner');
} else {
  document.querySelector('#MainContent').closest('body').classList.add('no--banner');
}


// buy now

function instantBuy(event) {
  console.log(event.target.parentNode);
  // let form = document.querySelector('form[action="/cart/add"]');
  let form = event.target.closest('form[action="/cart/add"]');
  let formData = new FormData(form);
  fetch('/cart/clear', {
  }).then(function (response) {
    if (response.ok) {
      fetch('/cart/add', {
        method: 'POST',
        body: formData
      }).then(function (addresponse) {
        if (addresponse.ok) {
          location.href='/checkout';
          return addresponse.json();
        }
        throw response;
      }).then(function (data) {
        console.log(data);
      }).catch(function (error) {
        console.warn(error);
      });
    }

  }).then(function (data) {
    console.log(data);
  }).catch(function (error) {
    console.warn(error);
  });
}


// Product page 
  var productmySwiper = new Swiper(".productmySwiper", {
    grabCursor: true,
    navigation: {
      nextEl: ".swiper-button-next",
      prevEl: ".swiper-button-prev",
    },
  });

  var ModalproductmySwiper = new Swiper(".ModalproductmySwiper", {
    grabCursor: false,
    navigation: {
      nextEl: ".modalswiper-button-next",
      prevEl: ".modalswiper-button-prev",
    },
    zoom: {
      maxRatio: 5,
      minRatio: 1
    },
  
    // on: {
    //   slideChangeTransitionEnd: function () {
    //     console.log('clicked!')
    //     // this.zoom.in();
    //     ScrollZoom(event,$('#container'),5,0.5);
    //   }
    // },
  });
  // mouse hover code 
  // var swiperSlide = document.getElementsByClassName('swiper-slide')
  // for(var index = 0; index< swiperSlide.length; index++){
  // swiperSlide[index].addEventListener('mouseover',function(e){
  //   ModalproductmySwiper.zoom.in();
  // })
  
  // swiperSlide[index].addEventListener('mouseout',function(e){
  //   ModalproductmySwiper.zoom.out();
  // })
  // }



const popup = document.getElementById("customerdropdown");
const trigger = document.querySelector("#dropdowntriger svg");

const trigger_menu = document.querySelector(".header__icon.header__icon--menu svg");

trigger.addEventListener("click", (e) => {
  popup.classList.toggle("active");
});

// Close popup when user clicks outside of it
document.addEventListener("click", (event) => {
  if (event.target !== popup && event.target !== trigger) {
   // console.log('if');
    popup.classList.remove("active");
  }else{
    // console.log('else event');
  }

  if (event.target !== trigger_menu) {
    // console.log(event.target);
    // console.log(trigger_menu);
    // console.log('if');
    document.querySelector("#Details-menu-drawer-container").removeAttribute("open");
    document.querySelector("#Details-menu-drawer-container").classList.remove('menu-opening');
    document.querySelector(".header__icon.header__icon--menu").setAttribute("aria-expanded",false);
  }


});


  // function toggleFunction(event) {
  //   event.currentTarget.classList.toggle("active");
  //   document.querySelector(".customer-dropdown").classList.toggle("active");
  // }
document.querySelector('button.shopify-payment-button__button').style.display = "none";
  setTimeout(function(){
    // console.log('buy now');
  document.querySelector('button.shopify-payment-button__button').innerHTML="Buy now";
  document.querySelector('button.shopify-payment-button__button').style.display = "block";
},1500);